<template>
    <div name="barocare-b2c-apply-popup">   
        <div class="row" style="justify-content: space-around">
            <div>
                <img src="../../assets/pc_barocare_b2c/phone_duotone.png" />
                <span class="title">간편 상담 신청 <span class="title-color">바로가기</span></span>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;">
            <span class="label">이름</span>
            <input v-model="name" class="input" placeholder="이름" />
        </div>        
        <div class="row" style="margin-top: 7px;">
            <span class="label">연락처</span>
            <input v-model="phone" class="input" placeholder="(-)제외 입력" />
        </div>
        <div class="row" style="margin-top: 13px;">
            <div>
                <img @click="agree" class="checkbox" v-if="isagree" src="../../assets/pc_barocare_b2c/checkbox-active.png" />
                <img @click="agree" class="checkbox" v-else src="../../assets/pc_barocare_b2c/checkbox-inactive.png" />
                <span class="agree-text" @click="agree">개인정보수집이용동의</span>
            </div>
            <span class="link-text" @click="viewPrivacy">내용 보기</span>
        </div>
        <div class="row">
            <div @click="sendToSlack" class="apply-button">
                상담 신청하기
            </div>  
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'barocareB2cApplyPopup',
    data: function()
    {
        return {
            name: '',
            phone: '',
            isagree: false
        }
    },
    methods: {
        agree: function(){
            this.isagree = !this.isagree
        },
        sendToSlack: async function()
        {
            if(this.name === null || this.name === '' || this.name === undefined)
            {
                alert("이름을 입력해주세요")   
                return;
            }

            if(this.phone === null || this.phone === '' || this.phone === undefined)
            {
                alert("휴대폰번호를 입력해주세요")   
                return;
            }
            
            if(!this.isagree)
            {
                alert("개인정보수집이용에 동의해주세요")
                return
            }
            //axios call


           
            await this.sendToSlackRequest();

        },
        sendToSlackRequest: async function()
        {            
            const data = {
                "name": this.name,
                "phone": this.phone
            }

            try {
                const response = await axios.post('https://utilapi.soldoc.co.kr/soldoc/v1/crm/barocare', data)  
                this.name = '';
                this.phone = '';    
                this.isagree = false;         
                alert("상담 신청 완료되었습니다.")                 
                console.log("response >>", response.data)
            } catch(err) {
                console.log("Error >>", err);
            }
        },
        viewPrivacy: function(){
            window.open("https://policy.soldoc.co.kr/barocare", "_blank")
        }
    }
}
</script>

<style scoped>

    .input {
        border-radius: 6px;
        border: 1px solid #D6D6D6;
        background: #FFF;
        height: 45px;
        flex-shrink: 0;
        color: #999;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px; /* 187.5% */
        letter-spacing: -0.32px;
        padding-left: 12px;
        width: 221px; 
    }

    .row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 282px;
    }

    .title {
        color: #008DEF;
        text-align: center;
        font-family: Pretendard;
        font-size: 22px;
        font-style: normal;
        font-weight: 600;
        line-height: 30px; /* 136.364% */
        letter-spacing: -0.44px;
    }
    .title-color {
        color: #1E4A96;
        font-family: Pretendard;
        font-size: 22px;
        font-style: normal;
        font-weight: 600;
        line-height: 30px;
        letter-spacing: -0.44px;
    }
    .label {      
        color: #1A1A1A;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 30px; /* 166.667% */
        letter-spacing: -0.36px;
        width: 46px;
    }
    .checkbox {
        width: 18px;
        cursor: pointer;
    }
    .agree-text {
        color: #1A1A1A;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px; /* 187.5% */
        letter-spacing: -0.32px;
        margin-left: 15px;
        cursor: pointer;
    }
    .link-text {
        color: #666;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 30px; /* 214.286% */
        letter-spacing: -0.28px;
        cursor: pointer;
        text-decoration-line: underline;
    }
    .apply-button {
        width: 282px;
        height: 52px;
        flex-shrink: 0;
        border-radius: 6px;
        background: #008DEF;
        color: #FFF;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 30px; /* 166.667% */
        letter-spacing: -0.36px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 16px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_barocare_b2c/BarocareB2cApplyPopup.vue